export var CLAUSE_TYPE_COMPOUND = 'compound';
export var CLAUSE_TYPE_TERMINAL = 'terminal';
export var CLAUSE_TYPE_NOT = 'not';